import { plainStore } from './safeStoring';


export const getDarkModePreference = (theme, systemDefault = false) => {
    plainStore('appTheme', theme);
    if (theme === 'light') {
      return false;
    } else if (theme === 'dark') {
      return true;
    } else {
      return systemDefault;
    }
};
